
import ItemNotFound from '@/components/common/ItemNotFound.vue'
import PageHeader from '@/components/common/PageHeader.vue'
import SupplierList from '@/components/supplier/SupplierList.vue'
import DataTableMixin from '@/components/mixins/DataTableMixin.vue'
import { EXPORT_SUPPLIERS, FETCH_SUPPLIERS, SET_HAVE_NEW_EXPORT_RECORD } from '@/store/actions'
import { FILTER_DEBOUNCE_TIME } from '@/utils/constants'
import errorHandler from '@/utils/errorHandler'
import { EExportType, ESmartBarcodeMenu } from '@/utils/enums'
import { Options } from 'vue-class-component'
import { Mixins } from 'vue-property-decorator'
import debounce from 'lodash/debounce'

interface ISupplierSearch {
  supplierCode?: string
  sortBy?: string
  sortType?: string
  [key: string]: string | undefined
}

@Options({
  components: { PageHeader, ItemNotFound, SupplierList },
  name: ESmartBarcodeMenu.SUPPLIERS,
})
export default class Suppliers extends Mixins(DataTableMixin) {
  dataSearch: ISupplierSearch = {}
  debounceFilter!: () => void

  get isSupplierLoading(): boolean {
    return this.$store.getters.isSupplierLoading || false
  }

  get getSupplierTotalRecords(): number {
    return this.$store.getters.getSupplierTotalRecords || 0
  }

  get getSuppliers() {
    return this.$store.getters.getSuppliers || []
  }

  refreshSupplierList() {
    this.debounceFilter()
  }

  currentPageChange(pageNum: number) {
    this.currentPageNum = pageNum
    this.redirectIndex()
    this.fetchList()
  }

  async exportCSV() {
    try {
      await this.$store.dispatch(EXPORT_SUPPLIERS, {
        sortBy: this.dataSearch.sortBy,
        sortType: this.dataSearch.sortType,
      })
      this.$store.commit(SET_HAVE_NEW_EXPORT_RECORD, { exportType: EExportType.MASTER_DATA, isHaveNew: true })
    } catch (e) {
      errorHandler(e)
    }
  }

  handleSortChange(data: { prop: string; order: string | null }) {
    this.dataSearch.sortBy = data.prop
    this.dataSearch.sortType = data.order ? (data.order === 'ascending' ? 'asc' : 'desc') : undefined
    this.currentPageNum = 1
    this.redirectIndex()
    this.fetchList()
  }

  fetchList() {
    try {
      this.$store.dispatch(FETCH_SUPPLIERS, {
        page: this.currentPageNum,
        limit: this.itemsPerPage,
        supplierCode: this.dataSearch.supplierCode || '',
        sortBy: this.dataSearch.sortBy,
        sortType: this.dataSearch.sortType,
      })
    } catch (e) {
      errorHandler(e)
    }
  }

  get isMarumiyaPackage() {
    return this.$store.getters.isMarumiyaPackage
  }

  created() {
    if (this.isMarumiyaPackage) {
      this.$router.push({ name: 'home' })
      return
    }
    this.routeName = 'suppliers'
    this.getQueryData()
    this.debounceFilter = debounce(() => {
      this.currentPageNum = 1
      this.redirectIndex()
      this.fetchList()
    }, FILTER_DEBOUNCE_TIME)
    this.fetchList()
  }
}
